export default __webpack_public_path__ + "static/media/roller5.8b3dc187.gif";